import { Helmet } from "react-helmet-async";
import { createFileRoute } from "@tanstack/react-router";
import { useState, useEffect } from "react";

import Footer from "@/components/layout/Footer";
import { AppPromo } from "@/features/landing";
import { PlansSidebar } from "@/features/planner";

import { 
  HeroLanding, 
  PromotionsJustForYou, 
  PopularPublicPlans, 
  ExploreItaly, 
  TestimonialsLanding 
} from "@/features/landing";

export const Route = createFileRoute("/landing")({
  component: Landing,
});

function Landing() {
  const [showPlans, setShowPlans] = useState(false);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && setShowPlans(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <main className="bg-white text-slate-900 min-h-screen">
      <Helmet>
        <title>TravelHug | Discover Journeys</title>
      </Helmet>

      {/* The HeroLanding now has the bespoke header integrated to match the Figma overlap precisely. */}
      <HeroLanding onOpenPlans={() => setShowPlans(true)} />
      
      <PromotionsJustForYou />
      <PopularPublicPlans />
      <ExploreItaly />
      <TestimonialsLanding />
      
      <AppPromo />
      <Footer />

      <PlansSidebar open={showPlans} onClose={() => setShowPlans(false)} />
    </main>
  );
}
